export class Log {
    static create(name) {
        return new Log(name);
    }
    name;
    constructor(name) {
        this.name = name;
        const category = `[${name}]`;
        this.debug = console.log.bind(console, category);
        this.info = console.info.bind(console, category);
        this.warn = console.warn.bind(console, category);
        this.error = console.error.bind(console, category);
    }
    debug;
    info;
    warn;
    error;
}
